import React, { useState } from "react";

// Hooks
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useScreenWidth from "~/hooks/useScreenWidth";
import { displayTooltip } from "~/hooks/displayTooltip";

//  Actions
import { success } from "~/redux/actions/snackbar-actions";

// Utils
import { copyToClipboard } from "~/utils/helperFunctions";
import { dateFormat } from "~/utils/date-format";
import { MESSAGES } from "~/utils/message";
import { stringLength } from "~/utils/helperFunctions";

// Components
import Loader from "~/components/General/Loader";

// MUI Components
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Pagination,
  PaginationItem,
  Typography,
  Tooltip,
  Stack,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";

// Icons
import { HideWebhookCIcon, ShowWebhookCIcon, CopyWebhookCIcon, EditWebhookCIcon, DisableCIcon, CheckmarkCIcon, DeleteWebhookCIcon, NoContactCIcon } from "~/assets/images";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

// Styles
import "./styles.scss";


const WebhookListing = (props) => {
  const {
    setDeleteWebhookModal,
    setActionWebhookModal,
    setSelectedWebhook,
    updatePagination,
  } = props;

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [showSecrectKey, setSecretKey] = useState([]);

  const rows = useSelector((state) => state.webhooksReducers.webhooks);
  const rowsCount = useSelector((state) => state.webhooksReducers.rowsCount);
  const to = useSelector((state) => state.webhooksReducers.to);
  const from = useSelector((state) => state.webhooksReducers.from);
  const lastPage = useSelector((state) => state.webhooksReducers.lastPage || 1);
  const currentPage = useSelector(
    (state) => state.webhooksReducers.currentPage || 1
  );
  const isLoading = useSelector((state) => state.webhooksReducers.loading);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleShow = (id, event) => {
    event.stopPropagation();
    setSecretKey((prev) => [...prev, id]);
  };

  const handleHide = (id, event) => {
    event.stopPropagation();
    const value = showSecrectKey.filter((key) => key !== id);
    setSecretKey(value);
  };

  const handleDelete = (row, event) => {
    event.stopPropagation();
    setSelectedWebhook(row);
    setDeleteWebhookModal(true);
  };

  const handleUpdate = (row, event) => {
    event.stopPropagation();
    navigate(`/settings/webhooks/update/${row.id}`);
  };

  const handleDisable = (row, event) => {
    event.stopPropagation();
    setSelectedWebhook(row);
    setActionWebhookModal(true);
  };

  const copyKey = (key, event) => {
    event.stopPropagation();
    copyToClipboard(key);
    dispatch(success(MESSAGES.SETTINGS.API_KEYS.COPY_KEY));
  };

  const handleRowClick = (params, event) => {
    if (event.ctrlKey || event.metaKey) {
      window.open(`/webhooks/${params.id}`, "_blank");
    } else {
      navigate(`/webhooks/${params.id}`);
    }
  };

  const handleChangePage = (event, newPage) => {
    updatePagination({
      page: newPage,
      pageSize: 10,
    });
  };

  const isTooltip = displayTooltip();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [activeRowId, setActiveRowId] = useState(null);
  const isScreen = useScreenWidth();

  const columns = [
    {
      field: "callbackUrl",
      headerName: "URL",
      width: 200,
      flex: window.innerWidth >= 1199 ? 1 : 0,
      sortable: false,
      renderCell: (params) =>
        stringLength(`${params.row.callbackUrl}`, 20) ? (
          <Tooltip
            title={params.row.callbackUrl}
            disableHoverListener={isTooltip}
          >
            <Box className="addressWrapper">
              <Typography>{params.row.callbackUrl || " -"}</Typography>
            </Box>
          </Tooltip>
        ) : (
          <Box className="addressWrapper">
            <Typography>{params.row.callbackUrl || " -"}</Typography>
          </Box>
        ),
    },
    {
      field: "topic",
      headerName: "Description",
      width: 200,
      flex: window.innerWidth >= 1199 ? 1 : 0,
      sortable: false,
      renderCell: (params) =>
        stringLength(`${params.row.topic}`) ? (
          <Tooltip title={params.row.topic} disableHoverListener={isTooltip}>
            <Box className="addressWrapper">
              <Typography>{params.row.topic || " -"}</Typography>
            </Box>
          </Tooltip>
        ) : (
          <Box className="addressWrapper">
            <Typography>{params.row.topic || " -"}</Typography>
          </Box>
        ),
    },
    {
      field: "status",
      headerName: "Status",
      type: "number",
      flex: window.innerWidth >= 1199 ? 1 : 0,
      width: 100,
      sortable: false,
      renderCell: (params) => (
        <Box className="addressWrapper">
          <Typography>{params.row.status || " -"}</Typography>
        </Box>
      ),
    },
    {
      field: "secret",
      headerName: "Secret Key",
      width: 200,
      flex: window.innerWidth >= 1199 ? 1 : 0,
      sortable: false,
      renderCell: (params) => (
        <Box className="secretKey">
          <Tooltip
            title={
              showSecrectKey.includes(params.row.id) ? params.row.secret : ""
            }
          >
            <input
              type={
                showSecrectKey.includes(params.row.id) ? "text" : "password"
              }
              value={
                showSecrectKey.includes(params.row.id)
                  ? params.row.secret
                  : params.row.secret.slice(0, 13)
              }
              readOnly
            />
          </Tooltip>
          <Box className="hideShow">
            {showSecrectKey.includes(params.row.id) ? (
              <img
                src={HideWebhookCIcon}
                alt="hide"
                onClick={(e) => handleHide(params.row.id, e)}
              />
            ) : (
              <img
                src={ShowWebhookCIcon}
                alt="show"
                onClick={(e) => handleShow(params.row.id, e)}
              />
            )}
            <img
              src={CopyWebhookCIcon}
              alt="hide"
              onClick={(e) => copyKey(params.row.secret, e)}
            />
          </Box>
        </Box>
      ),
    },
    {
      field: "createdAt",
      headerName: "Created Date",
      width: 200,
      flex: window.innerWidth >= 1199 ? 1 : 0,
      sortable: false,
      renderCell: (params) => (
        <Box className="addressWrapper">
          <Typography>{dateFormat(params.row.createdAt) || " -"}</Typography>
        </Box>
      ),
    },
    {
      field: "lastAccessAt",
      headerName: "Last Used Date",
      width: 200,
      flex: window.innerWidth >= 1199 ? 1 : 0,
      sortable: false,
      renderCell: (params) => (
        <Box className="addressWrapper">
          <Typography>{dateFormat(params.row.lastAccessAt) || " -"}</Typography>
        </Box>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      flex: window.innerWidth >= 1199 ? 1 : 0,
      sortable: false,
      renderCell: (params) => (
        <>
          {isScreen ? (
            <Box className="webhookTableActions">
              <Tooltip
                title={params.row.status === "Enabled" ? "Disable" : "Enable"}
              >
                <img
                  src={params.row.status === "Enabled" ? DisableCIcon : CheckmarkCIcon}
                  alt="disable"
                  onClick={(e) => handleDisable(params.row, e)}
                />
              </Tooltip>
              <Tooltip title="Edit">
                <img
                  src={EditWebhookCIcon}
                  alt="edit"
                  onClick={(e) => handleUpdate(params.row, e)}
                />
              </Tooltip>
              <Tooltip title="Delete">
                <img
                  src={DeleteWebhookCIcon}
                  alt="delete"
                  onClick={(e) => handleDelete(params.row, e)}
                />
              </Tooltip>
            </Box>
          ) : (
            <Box>
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? "long-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={(event) => {
                  setActiveRowId(params.row.id); // Set active row ID when the menu is opened
                  handleClick(event);
                }}
              >
                <MoreVertIcon
                  sx={{
                    color:
                      activeRowId === params.row.id && anchorEl
                        ? "#ed5c2f"
                        : "inherit",
                  }}
                />
              </IconButton>
              <Menu
                id="long-menu"
                MenuListProps={{
                  "aria-labelledby": "long-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                  style: {
                    maxWidth: "100px",
                  },
                  className: "webhookActionDropdown",
                }}
              >
                <MenuItem
                  onClick={(e) => {
                    handleDisable(params.row, e);
                    handleClose();
                  }}
                >
                  <img
                    src={params.row.status === "Enabled" ? DisableCIcon : CheckmarkCIcon}
                    alt="search"
                  />
                  {params.row.status === "Enabled" ? "Disable" : "Enable"}
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    handleUpdate(params.row, e);
                    handleClose();
                  }}
                >
                  <img src={EditWebhookCIcon} alt="Edit" />
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    handleDelete(params.row, e);
                    handleClose();
                  }}
                >
                  <img src={DeleteWebhookCIcon} alt="Delete" />
                  Delete
                </MenuItem>
              </Menu>
            </Box>
          )}
        </>
      ),
    },
  ];

  return (
    <div
      style={{
        marginTop: "25px",
        // width: "100%",
      }}
      className="webhookTableWrapper"
    >
      <DataGrid
        rows={rows}
        columns={columns}
        loading={isLoading}
        rowCount={rowsCount}
        onRowClick={handleRowClick}
        paginationMode="server"
        getRowId={(row) => row.id}
        hideFooterSelectedRowCount
        hideFooterPagination
        rowSelection={false}
        disableColumnMenu={true}
        className="webhookListing"
        slots={{
          noRowsOverlay: () => (
            <Stack className="noRowsTextContacts">
              <img src={NoContactCIcon} alt="NoContact" />
              {MESSAGES.NO_ROWS_TEXT}
            </Stack>
          ),
          noResultsOverlay: () => (
            <Stack className="noRowsTextContacts">
              <img src={NoContactCIcon} alt="NoContact" />
              {MESSAGES.NO_ROWS_TEXT}
            </Stack>
          ),
          loadingOverlay: Loader,
        }}
      />
      <Box className="webhookTablePagination">
        <Pagination
          count={lastPage}
          variant="outlined"
          shape="rounded"
          onChange={handleChangePage}
          page={currentPage}
          renderItem={(item) => (
            <PaginationItem
              slots={{
                previous: ArrowBackIosNewIcon,
                next: ArrowForwardIosIcon,
              }}
              {...item}
            />
          )}
        />
        <Typography>
          Showing {rowsCount ? from : 0} to {rowsCount < to ? rowsCount : to} of{" "}
          {rowsCount} results
        </Typography>
      </Box>
    </div>
  );
};

export default WebhookListing;
